// import axios, { HttpStatusCode } from 'axios';
import axios from 'axios';
import * as CryptoJS from 'crypto-js';

import authHeader from './auth-header';


// const URL_V2_API = 'https://api.squaregolf.com/v2';
const URL_V3_API = 'https://api.squaregolf.com/v3';

class _UserService {
  getUuid = async(username: string) => {
   return axios.get(URL_V3_API + '/user', {
    params: {
      username: username
    }
   })
   .then((res) => {
    // console.log(`user: ${JSON.stringify(res, null, 2)}`)
    if (res.data) {
      return res.data.uuid;
    }
   })
  }

  getUser = async(uuid: string) => {
    // console.log(`UserService.getUser:: uuid: ${uuid}`);

    return axios.get(URL_V3_API + '/user', {
        headers: authHeader(),
        withCredentials: true,
        params: { 
          uuid: uuid
        }
      })
      .then((res) => {
        return res;
      });
  }

  getProfile = async (uuid: string) => {
    // console.log(`UserService.getUser:: uuid: ${userUuid}`);
    let userUuid = localStorage.getItem("sub");

    if (uuid)
      userUuid = uuid;

    return axios.get(URL_V3_API + '/user/profile', {
        headers: authHeader(),
        withCredentials: true,
        params: { 
          userUuid: userUuid 
        }
      })
      .then((res) => {
        return res;
      });
  }

  // getPointBalance = async() => {
  //   let userStr = window.sessionStorage.getItem("user");

  //   if (userStr === undefined || userStr === null) {
  //     userStr = localStorage.getItem("user");
  //   }

  //   if (userStr === undefined || userStr === null) {
  //     console.log(`UserService.getPointBalance:: No user found in localStorage or sessionStorage`);
  //     return null;
  //   }

  //   if (userStr) {
  //     let user = JSON.parse(userStr);
      
  //     let response = await axios.get(URL_V2_API + "/point", {
  //       headers: authHeader(),
  //       withCredentials: true,
  //       params: { userUuid: user.uuid }
  //     });

  //     if (response.data) {
  //       console.log(JSON.stringify(response.data, null, 2));
  //       let wallet = response.data.wallet;

  //       return wallet.balance;
  //     }
  //   }

  //   return 0;
  // }

  // getCreditBalance = async() => {
  //   let userStr = window.sessionStorage.getItem("user");
  //   console.log(`UserService.getCreditBalance:: userStr from sessionStorage: ${userStr}`);
  //   if (userStr === undefined || userStr === null) {
  //     userStr = localStorage.getItem("user");
  //     console.log(`UserService.getCreditBalance:: userStr from localStorage: ${userStr}`);
  //   }
  //   if (userStr === undefined || userStr === null) {
  //     console.log(`UserService.getCreditBalance:: No user found in localStorage or sessionStorage`);
  //     return null;
  //   }

  //   if (userStr !== undefined && userStr !== null) {
  //     try {
  //       let user = JSON.parse(userStr);
  //       // console.log(`UserService.getCreditBalance:: user: ${JSON.stringify(user, null, 2)}`);
        
  //       let response = await axios.get(URL_V2_API + "/credit", {
  //         headers: authHeader(),
  //         withCredentials: true,
  //         params: { userUuid: user.uuid }
  //       });

  //       if (response.data) {
  //         // console.log(JSON.stringify(response.data, null, 2));
  //         let wallet = response.data.wallet;

  //         return wallet.balance;
  //       }
  //     } catch (error) {
  //       console.error(`UserService.getCreditBalance:: Error fetching credit balance: ${error}`);
  //     }
  //   }

  //   return null;
  // }

  // getAdmin() {
  //   return axios.get(URL_V2_API + '/admin', { 
  //     headers: authHeader(),
  //   });
  // }

  register(username: string, email: string, password: string) {
    console.log(`UserService.register:: username: ${username}, email: ${email}, password: ${password}`);

    let hashed = CryptoJS.SHA256(password).toString();
    console.log(`hashed password: ${hashed}`);

    return axios.post(URL_V3_API + '/user/register', {
      username,
      email,
      password: hashed,
    });
  }

  verifyEmail(uuid: string, token: string) {
    // console.log(`UserService.verifyEmail:: uuid: ${uuid}, token: ${token}`);

    return axios.get(URL_V3_API + "/user/verify", {
        params: {
          userUuid: uuid,
          token: token,
        },
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
          'Authorization': authHeader()['Authorization'] || '',
        }
      })
      .then((res) => {
        // console.log(`res: ${JSON.stringify(res, null, 2)}`);        
        return res.data;
      })
      .catch((err) => {
        // console.error(`Error verifying email: ${JSON.stringify(err, null, 2)}`);
        throw err;
      });
  }

  resendVerificationEmail(uuid: string) {
    console.log(`UserService.resendVerificationEmail:: userUuid: ${uuid}`);

    return axios.post(URL_V3_API + '/user/verify/resend', {
      userUuid: uuid,
    });
  }
  
  inquireUsername = async (email: string) => {
    console.log(`UserService.inquireUsername:: email:${email}`);

    return axios.post(URL_V3_API + '/user/inquire/username', {
      email: email,
    });
  }

  inquirePassword = async (username: string, email: string) => {
    console.log(`UserService.inquirePassword:: username: ${username}, email: ${email}`);

    return axios.post(URL_V3_API + '/user/inquire/password', {
      username: username,
      email: email,
    });
  }

  checkPasswordResetTokenValidity = async (uuid: string, token: string) => {
    // console.log(`UserService.checkPasswordResetToken:: token: ${token}`);

    let response = await axios.get(URL_V3_API + '/user/token', {
      params: { userUuid: uuid }
    });

    // console.log(`response: ${JSON.stringify(response.data, null, 2)}`);

    if (response.data) {
      let checkToken = response.data.passwordResetToken;

      if (checkToken) {
        // console.log(`check: ${checkToken}, token: ${token}, equality: ${checkToken === token}`);

        if (checkToken === token) {
          let tokenExpiry = response.data.passwordResetTokenExpiresAt;
          // console.log(`check: ${new Date(tokenExpiry)}, now: ${new Date()}`);

          if (new Date(tokenExpiry) > new Date()) {
            return { tokenStatus: 'Valid' };
          }
          return { tokenStatus: 'Expired' };
        }
      } else {
        throw new Error('Invalid or expired token');
      }
    }

    throw new Error('Invalid or expired token');
  }

  resetPassword = async (uuid: string, token: string, newPassword: string) => {
     console.log(`UserService.resetPassword:: userUuid: ${uuid}, token: ${token}, newPassword: ${newPassword}`);

    let hashed = CryptoJS.SHA256(newPassword).toString();
    console.log(`hashed new password: ${hashed}`);

    return axios.post(URL_V3_API + '/user/reset-password', {
      uuid: uuid,
      token: token,
      password: hashed,
    });
  }
}


const UserService = new _UserService();
export default UserService;
